import { useAuth } from '@/hooks/useAuth';
import { AppRouters } from '@/utils/constants/routers';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

export const PublicRoute = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate(AppRouters.home);
    }
  }, [isAuthenticated]);

  if (loading || isAuthenticated) return null;

  return <>{children}</>;
}; 